import Component from '../core/Component'
import { queries } from '../core/config'
import enquire from 'enquire.js'

export default class BookingBA extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.ref = {
            filter: null,
            filterOpener: null,
            filterClose: null,
            booking: null,
            scripts: [],
        }

        this.hasFilter = !!this.ref.filter

        this.enquireHandler = {
            match: () => this.match(),
            unmatch: () => this.unmatch(),
        }
    }

    prepare() {
        if (this.hasFilter) {
            this.filterParent = this.ref.filter.parentNode
            this.ref.filterOpener.addEventListener('click', this.handleFilterOpenerClick)
            this.ref.filterClose.addEventListener('click', this.handleFilterOpenerClick)
        }

        if (!window.isBALoadingFromDOM) {
            this.reload()
        }

        enquire.register(queries.smallWideMax, this.enquireHandler)

        if (window.CookieConsent && window.CookieConsent.consented === false) {
            document.addEventListener('consentUpdate', this.handleConsentUpdate)
        }

        const scripts = this.ref.scripts.filter((element) => element.dataset.src)
        scripts.forEach((element) => (element.src = element.dataset.src))
    }

    destroy() {
        enquire.unregister(queries.smallWideMax, this.enquireHandler)
    }

    match() {
        if (!this.hasFilter) {
            return
        }

        document.body.appendChild(this.ref.filter)
        this.ref.filter.classList.add('is-mobile')
        this.ref.filter.classList.remove('is-open')
    }

    unmatch() {
        if (!this.hasFilter) {
            return
        }

        this.filterParent.appendChild(this.ref.filter)
        this.ref.filter.classList.remove('is-mobile')
    }

    handleConsentUpdate = () => {
        setTimeout(() => {
            window.location.reload()
        }, 500)
    }

    handleFilterOpenerClick = () => {
        this.ref.filter.classList.toggle('is-open')
    }

    reload() {
        this.element.classList.remove('is-ba-loaded')
        const iframe = this.ref.booking.querySelector('iframe')
        iframe.addEventListener('load', () => {
            this.element.classList.add('is-ba-loaded')
        })
    }
}
